import React, { Component } from "react";
import FarmShopConnectLogo from "../../images/FarmShopConnectLogo.png";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import AuthService from "../../session/AuthService";
import LoginService from "../../api/LoginService";
import { Toaster , toast } from "react-hot-toast"





class Otp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 1,
      otpValue: "",
      seconds: 60,
      timerRunning: true,
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  startTimer = () => {
    this.setState({ timerRunning: true });
    this.intervalId = setInterval(() => {
      this.setState(
        (prevState) => ({
          seconds: prevState.seconds - 1,
        }),
        () => {
          if (this.state.seconds <= 0) {
            this.clearTimer();
          }
        }
      );
    }, 1000);
  };

  clearTimer = () => {
    clearInterval(this.intervalId);
    this.setState({ timerRunning: false });
  };

  render() {
    const { seconds, timerRunning } = this.state;
    return (
      <>
        <div className="login-page">
          <div className="logo-container">
            <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
          </div>
          <div className="login-card-otp">
            <h5 style={{ fontWeight: "700" }}>Enter OTP</h5>
            <p style={{ color: "#545454" }}>Enter Your Credentials Below:</p>

            {/* <div style={{fontSize : "13px" , fontWeight : "bold" , marginBottom : "10px" }} onClick={this.resesendOtp}>RESEND</div> */}
            {timerRunning ? (
              <p>00:{seconds.toString().length=== 1 ? "0" + seconds : seconds}</p>
            ) : (
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  cursor : "pointer"
                  

                }}
                onClick={this.handleResend}
              >
               <u>Resend</u> 
              </div>
            )}
            <div className="otp-input" style={{ marginBottom: "20px" }}>
              <input
                type="text"
                maxLength="1"
                className="otp-box"
                onChange={this.handleChange}
                id="otpInput1"
                onKeyDown={this.handleKeyDown}
              />
              <input
                type="text"
                maxLength="1"
                className="otp-box"
                onChange={this.handleChange}
                id="otpInput2"
                onKeyDown={this.handleKeyDown}
              />
              <input
                type="text"
                maxLength="1"
                className="otp-box"
                onChange={this.handleChange}
                id="otpInput3"
                onKeyDown={this.handleKeyDown}
              />
              <input
                type="text"
                maxLength="1"
                className="otp-box"
                onChange={this.handleChange}
                id="otpInput4"
                onKeyDown={this.handleKeyDown}
              />
            </div>
            {/* <div style={{fontSize : "13px" , fontWeight : "bold" , marginBottom : "10px"   }}>{this.state.seconds}</div> */}
            {!timerRunning && seconds <= 0 ? <p>Time's up!</p> : null}

            <div
              className="allign-button-onOtp"
              style={{ paddingLeft: "36px" }}
            >
              <button
                type="button"
                className="btn btn-success"
                id="successbutton"
                onClick={this.openResetPassword}
                style={{ fontFamily: "Karla" }}
              >
                Submit
              </button>
            </div>
          </div>
          <small className="mt-2" style={{ color: "#545454" }}>An OTP has been sent to your registered email address. Please check your inbox or <b>spam folder</b> if you don't see it in your primary mailbox.</small>
        </div>
        <Toaster />
      </>
    );
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // Prevent the default Enter key behavior (e.g., submitting a form)
      event.preventDefault();
      
      // Call the openOtp function
      this.openResetPassword();
    }
  };

  handleResend = () => {

    if(this.props.stateForResend === "forgotpassword") {
      if (!this.state.timerRunning) {
        this.setState({ seconds: 60 }, () => {
          this.startTimer();
  
          LoginService.forgotPasswordMobile(this.props.mailId).then(
            (response) => {
              console.log("response", response.data.data);
  
              if (response.data.data === "otp send succesfully") {
               
              } else {
              }
            }
          );
        });
      }
    }else {
      if (!this.state.timerRunning) {
        this.setState({ seconds: 60 }, () => {
          this.startTimer();
  
            
          LoginService.firstTimeUserResend(this.props.mailId).then((response) => {
            console.log("response", response.data.data);
      
              if (response.data.data === "otp send succesfully") {
          
              } else {
              }
          })
        });
      }
    }

   
  };

  handleChange = (event) => {
    const { value, maxLength, id } = event.target;

    if (value.length === maxLength) {
      // Move to the next input field if a value is entered
      const nextIndex = parseInt(id.slice(-1)) + 1;
      if (nextIndex <= 4) {
        const nextInput = document.getElementById(`otpInput${nextIndex}`);
        nextInput.focus();
      }
    } else if (value.length === 0) {
      // Move to the previous input field if backspace is pressed
      const prevIndex = parseInt(id.slice(-1)) - 1;
      if (prevIndex >= 1) {
        const prevInput = document.getElementById(`otpInput${prevIndex}`);
        prevInput.focus();
      }
    }

    const updatedOtpValue =
      this.state.otpValue.slice(0, parseInt(id.slice(-1)) - 1) +
      value +
      this.state.otpValue.slice(parseInt(id.slice(-1)));
    this.setState({ otpValue: updatedOtpValue });
  };

  openResetPassword = () => {

    if(this.state.otpValue.length === 4){
      let obj = {
        otp: this.state.otpValue,
        mailId: this.props.mailId.mailId,
      };
  
      LoginService.checkOTPVaild(obj).then((response) => {
        console.log("response" , response);
        if (response.data.data.valid === true) {
          AuthService.storeOtpMailid(this.props.mailId);
          this.props.history.replace("/Resetpassword");
        } else if(response.data.data.valid === false) {
         
          toast.error("Entered OTP is wrong. Please try again")
  
        }
      });
    }else {
      toast.error("Please Enter Otp")
    }
    
  };
}
export default withRouter(Otp);
